/* ===========================================================
   sync/memstore.js — the same store, kept in memory

   Used for signed-out viewers of a shared link (nothing to keep) and
   by the tests, which drive the real sync code without a browser.
   =========================================================== */

export class MemoryStore {
  constructor() {
    this.k = 0;
    this.rows = [];
    this.meta = new Map();
    this.docs = new Map();
    this.outbox = [];
    this.kv = new Map();
    this.conf = new Map();
    this.files = new Map();
  }

  async entries(doc) { return this.rows.filter(r => r.doc === doc).map(r => ({ ...r })); }
  async addEntry(doc, data, pending, cid = 0) {
    const k = ++this.k;
    this.rows.push({ k, doc, data, pending: pending ? 1 : 0, cid, at: Date.now() });
    return k;
  }
  async ack(keys) { for (const r of this.rows) if (keys.includes(r.k)) r.pending = 0; }
  async compactSynced(doc, data, upToKey) {
    this.rows = this.rows.filter(r => !(r.doc === doc && !r.pending && r.k <= upToKey));
    this.rows.push({ k: ++this.k, doc, data, pending: 0, cid: 0, at: Date.now() });
  }
  async pendingDocs() { return [...new Set(this.rows.filter(r => r.pending).map(r => r.doc))]; }
  async getMeta(doc) { return this.meta.get(doc) || null; }
  async setMeta(doc, patch) { this.meta.set(doc, { ...(this.meta.get(doc) || { doc, lastSeq: 0 }), ...patch, doc }); }
  async dropDoc(doc) {
    this.rows = this.rows.filter(r => r.doc !== doc);
    this.meta.delete(doc); this.docs.delete(doc); this.conf.delete(doc);
  }

  async listDocs() { return [...this.docs.values()]; }
  async getDocRec(id) { return this.docs.get(id) || null; }
  async putDocRec(rec) { this.docs.set(rec.id, rec); }
  async patchDocRec(id, patch) { const cur = this.docs.get(id); if (cur || patch.id) this.docs.set(id, { ...(cur || {}), ...patch, id }); }
  async delDocRec(id) { this.docs.delete(id); }

  async addOp(op) { const k = ++this.k; this.outbox.push({ ...op, k, at: Date.now() }); return k; }
  async ops() { return [...this.outbox]; }
  async removeOp(k) { this.outbox = this.outbox.filter(o => o.k !== k); }

  async getKV(k) { return this.kv.get(k); }
  async setKV(k, v) { this.kv.set(k, v); }

  async getConflicts(doc) { return this.conf.get(doc) || null; }
  async setConflicts(doc, v) { this.conf.set(doc, { ...v, doc }); }
  async clearConflicts(doc) { this.conf.delete(doc); }

  async listFiles() { return [...this.files.values()]; }
  async getFile(key) { return this.files.get(key) || null; }
  async putFile(rec) { this.files.set(rec.key, rec); }
  async delFile(key) { this.files.delete(key); }

  async destroy() {}
}
